module.exports = __webpack_public_path__ + "img/feedback.aed232d2.svg";